/**
 * Product Layout Premium — offer collect + share modal init.
 * Gallery handled by product-gallery-swiper.js
 */
(function () {
  'use strict';

  function initShare(root) {
    if (!root.querySelector('.productView-share')) return;
    if (typeof window.shareProduct !== 'function') return;
    if (!customElements.get('share-button')) {
      window.shareProduct();
    }
  }

  class PLPOfferCollect {
    constructor(root) {
      root.querySelectorAll('.plp-offer-card__collect').forEach((btn) => {
        btn.addEventListener('click', () => {
          const code = btn.dataset.code;
          if (!code) return;

          if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(code).then(() => {
              const original = btn.textContent;
              btn.textContent = btn.dataset.copied || 'Copied!';
              window.setTimeout(() => {
                btn.textContent = original;
              }, 2000);
            });
          } else {
            btn.textContent = code;
          }
        });
      });
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return;
    initShare(sectionEl);
    new PLPOfferCollect(sectionEl);
  }

  function boot() {
    document.querySelectorAll('[data-plp-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector('[data-plp-section]') ||
      event.target.closest('[data-plp-section]');
    if (section) initSection(section);
  });
})();
